import whatsappChatImg from "@/assets/whatsapp-chat-optimized.webp";
import whatsappChatSmall from "@/assets/whatsapp-chat-320.webp";

const WHATSAPP_URL = "https://wa.me/251911191347";

const StickyChat = () => (
    <div className="fixed bottom-[calc(env(safe-area-inset-bottom)+1rem)] left-6 z-50 sm:bottom-6 sm:left-8">
        <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
            title="Chat on WhatsApp"
            className="block rounded-lg transition-transform duration-200 hover:scale-[1.03] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#25D366]/40 focus-visible:ring-offset-2 motion-reduce:transition-none motion-reduce:hover:scale-100"
        >
            <img
                src={whatsappChatImg}
                srcSet={`${whatsappChatSmall} 320w, ${whatsappChatImg} 576w`}
                sizes="(max-width: 639px) 176px, (max-width: 1023px) 224px, 240px"
                alt=""
                width="576"
                height="209"
                loading="lazy"
                decoding="async"
                className="h-auto w-44 drop-shadow-xl sm:w-56 lg:w-60"
            />
        </a>
    </div>
);

export default StickyChat;
